const VERSION = "1.4.0";
export {
  VERSION
};
//# sourceMappingURL=axios11.js.map
